import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { FlightsFilterForm, PackageFilterForm } from 'frontend/components/filters';
import { useSearchTabs } from 'frontend/hooks/useSearchTabs';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ borderTopLeftRadius: '0px' }}>{children}</Box>}
    </div>
  );
}

const SearchTabs = ({
  enableSearchPackage,
  enableSearchFlights,
  isOnTargetPath,
  packageFormInput,
  packageDestinations,
  packageOrigins,
  handlePackageOrigin,
  handlePackageDestination,
  handleDateRangeSelect,
  flightFormInput,
  handleFlightOrigin,
  handleFlightDestination,
  handleFlightsDateRangeSelect,
  handleFlightPassenger,
  handleOccupationChange,
  handleIsOnlyOneWay,
  isDestinationEmpty,
  isOriginEmpty,
  isDatesEmpty,
  isTuristasEmpty,
  setIsOriginEmpty,
  setIsDatesEmpty,
  setTuristasEmpty,
  setIsDestinationEmpty,
  departureDate,
  handleSearchButton,
  linkTo,
  handleSearchFlightsButton,
  linkToFLights,
  background,
  text,
}) => {
  const { t } = useTranslation('layout');
  const { value, handleChange, getTabStyle, a11yProps, shouldRender } = useSearchTabs({
    enableSearchPackage,
    enableSearchFlights,
  });

  if (!shouldRender || !isOnTargetPath) return <></>;

  return (
    <Box sx={{ width: { xs: '94%', sm: '90%' } }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className="tabs_wrapper"
          TabIndicatorProps={{
            className: 'package-search__button--background',
            style: {
              backgroundColor: background,
              color: text,
            },
          }}
          onClick={() => {
            setIsOriginEmpty(false);
            setIsDatesEmpty(false);
            setTuristasEmpty(false);
            setIsDestinationEmpty(false);
          }}
        >
          <Tab
            label={t('searcher.search_packages')}
            {...a11yProps(0)}
            onFocus={() => handleOccupationChange(0)}
            style={getTabStyle(
              enableSearchPackage,
              {
                left: 10,
                right: enableSearchFlights ? 3 : 10,
              },
              2,
            )}
            className="tab"
            disabled={!enableSearchPackage}
            icon={
              <i
                className="fa fa-suitcase package-search__icon text-footer-default"
                style={{ color: background }}
              />
            }
            iconPosition="start"
          />
          <Tab
            label={t('searcher.search_flights')}
            {...a11yProps(1)}
            onFocus={() => handleOccupationChange(1)}
            style={getTabStyle(enableSearchFlights, {
              left: enableSearchPackage ? 3 : 10,
              right: 10,
            })}
            className="tab"
            disabled={!enableSearchFlights}
            icon={
              <i
                className="fa fa-plane package-search__icon text-footer-default"
                style={{ color: background }}
              />
            }
            iconPosition="start"
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className="header__package-search__container" id="search_package_container">
          <div className="package-search__form__fields">
            <PackageFilterForm
              formInput={packageFormInput}
              destinations={packageDestinations}
              origins={packageOrigins}
              handleOriginSelect={handlePackageOrigin}
              handleDestinationSelect={handlePackageDestination}
              handleDateRangeSelect={handleDateRangeSelect}
              handleOccupationChange={handleOccupationChange}
              isDestinationEmpty={isDestinationEmpty}
              isOriginEmpty={isOriginEmpty}
              isDatesEmpty={isDatesEmpty}
              isTuristasEmpty={isTuristasEmpty}
              setIsOriginEmpty={setIsOriginEmpty}
              setIsDatesEmpty={setIsDatesEmpty}
              setTuristasEmpty={setTuristasEmpty}
              setIsDestinationEmpty={setIsDestinationEmpty}
              departureDate={departureDate}
            />
            <div className="package-search__button-row">
              <Link
                to={linkTo}
                onClick={handleSearchButton}
                className="package-search__button big-package-search__button"
                style={{
                  backgroundColor: background,
                  color: text,
                }}
              >
                <i className="fa fa-search heading__icon" />
                <span>Buscar</span>
              </Link>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className="header__package-search__container" id="search_flight_container">
          <div className="package-search__form__fields">
            <FlightsFilterForm
              formInput={flightFormInput}
              handleOriginSelect={handleFlightOrigin}
              handleDestinationSelect={handleFlightDestination}
              handleDateRangeSelect={handleFlightsDateRangeSelect}
              handleFlightPassenger={handleFlightPassenger}
              handleOccupationChange={handleOccupationChange}
              isDestinationEmpty={isDestinationEmpty}
              isOriginEmpty={isOriginEmpty}
              isDatesEmpty={isDatesEmpty}
              isTuristasEmpty={isTuristasEmpty}
              setIsOriginEmpty={setIsOriginEmpty}
              setIsDatesEmpty={setIsDatesEmpty}
              setTuristasEmpty={setTuristasEmpty}
              setIsDestinationEmpty={setIsDestinationEmpty}
              handleIsOnlyOneWay={handleIsOnlyOneWay}
            />
            <div className="package-search__button-row">
              <Link
                to={linkToFLights}
                onClick={handleSearchFlightsButton}
                className="package-search__button big-package-search__button"
                style={{
                  backgroundColor: background,
                  color: text,
                }}
              >
                <i className="fa fa-search heading__icon" />
                <span>{t('common.search')}</span>
              </Link>
            </div>
          </div>
        </div>
      </CustomTabPanel>
    </Box>
  );
};

export default SearchTabs;
